import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import example01 from '@/pages/example01'
import example02 from '@/pages/example02'
import exampleList from '@/pages/exampleList'
import newsList from '@/pages/newsList'
import news from '@/pages/news'
import news02 from '@/pages/news02'
import contactOur from '@/pages/contactOur'
import aboutUs from '@/pages/aboutUs'

// import { createRouter, createWebHistory } from 'vue-router'


Vue.use(Router)

export default new Router({
	// history: createWebHistory(),
	mode: 'history',
	routes: [{
			path: '/',
			name: 'index',
			component: index
		},
		{
			path: '/newsList',
			name: 'newsList',
			component: newsList,
		},
		{
			path: '/news',
			name: 'news',
			component: news,
		},
		{
			path: '/news02',
			name: 'news02',
			component: news02
		}, {
			path: '/contactOur',
			name: 'contactOur',
			component: contactOur
		}, {
			path: '/exampleList',
			name: 'exampleList',
			component: exampleList
		}, {
			path: '/example01',
			name: 'example01',
			component: example01
		}, {
			path: '/example02',
			name: 'example02',
			component: example02
		}, {
			path: '/aboutUs',
			name: 'aboutUs',
			component: aboutUs
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js